'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bomb';
var width = 512;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M16 304c0 106 86 192 192 192s192-86 192-192c0-25.1-4.8-49-13.5-70.9l-1.9-4.9 3.7-3.7 23.1-23.1-101-101.1-25.4 22.9-3.6 3.3-4.6-1.8c-21.3-8.2-44.5-12.7-68.7-12.7-106 0-192 86-192 192zm48 0c0-79.5 64.5-144 144-144l8 0 0 16-8 0c-70.7 0-128 57.3-128 128l0 8-16 0 0-8z', 'M456 8l0 48 48 0 0 16-48 0 0 48-16 0 0-48-48 0 0-16 48 0 0-48 16 0zM312.3 77l5.4 5.4 50.3 50.3 26.3-26.3 5.7-5.7 11.3 11.3c-.3 .3-11 11-32 32l50.3 50.3 5.7 5.7c-.3 .3-11 11-32.1 32.1 8.3 22.4 12.8 46.6 12.8 71.9 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c24.5 0 48 4.2 69.8 12l28.8-26 5.6-5.1zm-.6 22l-26.8 24.1-3.6 3.3-4.6-1.8c-21.3-8.2-44.5-12.7-68.7-12.7-106 0-192 86-192 192s86 192 192 192 192-86 192-192c0-25.1-4.8-49-13.5-70.9l-1.9-4.9 3.7-3.7 24.4-24.4-101-101zM80 304l0 8-16 0 0-8c0-79.5 64.5-144 144-144l8 0 0 16-8 0c-70.7 0-128 57.3-128 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;